import { HS_EVENT_QUERY_PARAM, PAGE_TYPE } from './constants';
export const redirectToUrl = newUrl => {
  window.location.href = newUrl;
};
export const getQueryParams = (searchParam, url = window.location.search) => {
  const searchParams = new URLSearchParams(url);
  return searchParams.get(searchParam);
};
export const getRedirectUrl = (page, url = window.location.href, params = {}) => {
  const redirectUrl = new URL(url);
  const paths = redirectUrl.pathname.split('/');
  paths[paths.length - 1] = page;
  redirectUrl.pathname = paths.join('/');
  if (page === PAGE_TYPE.failure) {
    redirectUrl.search = '';
  }
  Object.entries(params).forEach(([key, value]) => {
    redirectUrl.searchParams.set(key, value);
  });
  return redirectUrl.toString();
};
export const getConfirmationPageUrl = ({
  hsEventCode
}) => {
  const params = {
    [`${HS_EVENT_QUERY_PARAM}`]: hsEventCode
  };
  const confirmUrl = getRedirectUrl(PAGE_TYPE.confirmation, undefined, params);
  return confirmUrl;
};
export const getPathSuffix = (url = window.location.pathname) => url ? url.split('/').pop() : '';
export function validateOrigin(url = window.location.origin) {
  return url.match(/^https:\/\/app(-[a-z0-9]+)?\.hubspot\.com$/) || url.match(/^https:\/\/(app|local)(-[a-z0-9]+)?\.hubspotqa\.com$/) || url.match(/^https?:\/\/localhost(:\d+)?$/);
}
export const getLanguageCodeFromUrl = (url = window.location.href) => {
  // regex to get language code from both account BU and BU links:
  // account BU: preferences-center/{language}/
  // BU: preferences-center/{business-unit-id}/{language}/
  const match = url.match(/preferences-center\/(?:\d+\/)?([^\/\?]+)(?:\/|$|\?)/);
  return match ? match[1] : null;
};